/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import i18n from 'i18n';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import Grid from '@material-ui/core/Grid';
import { makeStyles, Tooltip, Typography } from '@material-ui/core';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import { cyrb53Hash } from 'utils/helpers';
import {
  getAllPartnersOperatorRequest,
  setSelectedPartner,
} from 'modules/partners/actions';

import { modalClose } from 'modules/modal/actions';

import clsx from 'clsx';
import {
  AllPartnersFields,
  ListAllPartnersDataProps,
} from 'modules/partners/interfaces';
import { useTableFilters } from 'hooks/useTableFilters';
import { SearchBar } from 'components/SearchBar';
import { PartnerFieldsProps } from '.';
import styles from '../styles';

const initialQuery = {
  offset: 0,
  limit: 10,
  search: '',
};

interface Props {
  isLoading: boolean;
  companyFields: PartnerFieldsProps | null;
  allPartnersList: ListAllPartnersDataProps;
  setCompanyFields: (prop: PartnerFieldsProps | null) => void;
  getAllPartnersOperatorRequest: (props) => void;
  setSelectedPartner: (prop: AllPartnersFields | null) => void;
  modalClose: () => void;
}

const PartnerList = ({
  isLoading,
  companyFields,
  allPartnersList,
  getAllPartnersOperatorRequest,
  setCompanyFields,
  setSelectedPartner,
  modalClose,
}: Props) => {
  const headers = [
    {
      key: 'partner_name',
      i18n: 'PARTNER_NAME_KEY',
      order: true,
    },
    {
      key: 'company_name',
      i18n: 'COMPANY_NAME_KEY',
      order: true,
    },
  ];

  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const {
    itemOrder,
    query,
    searchValue,
    handleOrder,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters(initialQuery);

  const getPartners = () => {
    getAllPartnersOperatorRequest({
      ...query,
    });
  };

  React.useEffect(() => {
    getPartners();
  }, [query]);

  return (
    <Grid>
      <SearchBar
        id="search-partners"
        isLoading={isLoading}
        searchValue={searchValue}
        handleSearch={handleSearch}
        setSearchValue={setSearchValue}
      />
      <TableItems
        header={
          <>
            {headers.map(item => (
              <TableCell
                key={item?.key}
                order={item?.order}
                handleOrder={() =>
                  item?.order ? handleOrder(item?.key) : null
                }
                markOderItem={itemOrder === item?.key}
              >
                {i18n.t(item?.i18n)}
              </TableCell>
            ))}
          </>
        }
        renderItems={(item: AllPartnersFields, index) => (
          <TableRow
            key={cyrb53Hash(index)}
            onClick={() => {
              setCompanyFields({
                partner_name: item?.partner_name,
                partner_uuid: item?.partner_uuid,
              });
              setSelectedPartner(item);
              modalClose();
            }}
            className={clsx(classes.tableRow, {
              [classes.itemSelected]:
                companyFields?.partner_uuid === item?.partner_uuid,
            })}
          >
            <TableCell className={classes.companyCell}>
              <Tooltip title={item?.partner_name} arrow>
                <Typography className={classes.name}>
                  {item?.partner_name}
                </Typography>
              </Tooltip>
            </TableCell>
            <TableCell className={classes.companyCell}>
              <Tooltip title={item?.company_name} arrow>
                <Typography className={classes.name}>
                  {item?.company_name}
                </Typography>
              </Tooltip>
            </TableCell>
          </TableRow>
        )}
        overrideRowsCount={10}
        data={allPartnersList}
        isLoading={isLoading}
        onChangePage={handlePageChange}
        onChangeLimit={handleLimitChange}
        notFoundText={
          <Typography>{i18n.t('MONITOR.NO_RESULTS_INSTANCES')}</Typography>
        }
      />
    </Grid>
  );
};

const mapStateToProps = ({
  partners: { selectedCompany, allPartnersList, isLoading },
}: ApplicationState) => ({
  isLoading,
  selectedCompany,
  allPartnersList,
});

export default connect(mapStateToProps, {
  getAllPartnersOperatorRequest,
  setSelectedPartner,
  modalClose,
})(PartnerList);
